<template>
  <div class="content">
    <content-header title="返品・キャンセルについて" />
    <div class="content-body">
      <div class="content-subtitle subtitle-skyblue">【不良品】</div>
      <div style="margin:0 0 20px 15px;">
        不良による交換・返品をご希望される場合には下記の注意事項をご確認の上、商品到着後
        8 日以内に電話またはメールにて当社までご連絡ください。<br />
        商品到着後 8
        日以降の交換・返品には、応じかねる場合がありますのでご注意ください。交換・返品の送料は、当社で負担いたします。<br />
        送料着払いでご返品ください。
      </div>
      <div class="content-subtitle subtitle-skyblue">
        【汚損・破損等の返品】
      </div>
      <div style="margin:0 0 20px 15px;">
        お届けした商品に万一、汚損・破損等がございましたら、メールもしくは電話にて当社までご連絡ください。<br />
        当社もしくはメーカーより直接お客様へ迅速に正常品をお送りさせていただきます。送料着払いでご返品ください。<br />
        交換商品が売り切れ等でお渡しできない場合は、返金対応となりますので、ご了承ください。
      </div>
      <div class="content-subtitle subtitle-skyblue">
        【お客様都合による返品】
      </div>
      <div style="margin:0 0 20px 15px;">
        お客様のご都合による返品は、原則お受けできません。
      </div>
      <div class="content-subtitle subtitle-skyblue">【返金について】</div>
      <div style="margin:0 0 20px 15px;">
        ご指定の銀行口座に商品代金をお振込みいたします。<br />
        交換の場合の差額請求または支払いについては、差額が生じた際にお電話かメールでご連絡いたします。<br />
        お客様の御都合による返品につきましては、送料、銀行振込手数料はお客様負担となります。
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ContentHeader,
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/modules/guide/AboutCancel.vue